import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const assetsVuex = createNamespacedHelpers("assets");
const luckyVuex = createNamespacedHelpers("lucky");
const userVuex = createNamespacedHelpers("user");
import vailcode from "@utils/errcode";
import formatter from "@utils/formatter";
export default {
  name: "lucky",
  //转盘抽奖
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"]),
    ...assetsVuex.mapState(["assetsList", "assetsChainsList"]),
    ...userVuex.mapState(["userData"]),
    ...luckyVuex.mapState(["luckyList", "luckyItems", "luckyLogs", "luckyLogHasMore", "luckyLoading", "luckyLogCondition"]),
    fmt_pre() {
      return formatter.fmt_pre;
    }
  },
  data() {
    return {
      popSignShow: false,
      popUsdInviteShow: false,
      prizeIndex: 0,
      prizeList: null,
      isPopResult: false,
      //奖品结果弹窗显示状态
      selectRow: null,
      //抽到的奖品
      isStartLucky: false,
      //是否开始抽奖
      isLoadingLuckyList: null,
      //转盘列表loading
      isFlag: true,
      //防止按钮重复点击
      assetsInfo: {},
      isstockLoading: false,
      istapLoading: false,
      luckyInfo: {
        stock: {
          price_stock: 0,
          price_coin: 0,
          price_tap: 0
        },
        tap: {
          price_stock: 0,
          price_coin: 0,
          price_tap: 0
        }
      },
      awardInfo: {},
      scorllFlag: false,
      giftList: null,
      popGiftDetailShow: false,
      rowGift: null,
      popGiftSellShow: false,
      giftSellContent: null,
      rowGiftSellContent: null,
      myGiftList: null,
      myGiftListPage: {
        page: 1,
        limit: 10,
        isLoading: false,
        totalPages: 1
      },
      popMyGiftShow: false,
      adminName: "MemesGlo",
      isGiftSellLoading: false,
      isPopGiftSellClose: false,
      isGiftSellUpStarBalance: false,
      selectStockCountOption: 1,
      selectTapCountOption: 1,
      stockCountStep: 0,
      tapCountStep: 0,
      stockSelectCountOptions: 1,
      tapSelectCountOptions: 1,
      isSelectStock: -1,
      isSelectTap: -1
    };
  },
  watch: {
    popGiftSellShow: {
      handler(bool) {
        this.isGiftSellUpStarBalance = false;
        //  if(!bool) {
        //  } 
      }
    }
  },

  methods: {
    ...assetsVuex.mapActions(["getAssetsList"]),
    ...luckyVuex.mapActions(["getLuckyList", "getLuckyItems", "getLuckyLogs", "luckyDraw"]),
    ...luckyVuex.mapMutations(["setLuckyLogCondition", "setLuckyLogLoading"]),
    ...userVuex.mapMutations(["setUserData"]),
    setCountOption(type, selectType = "select") {
      const count_options = this.luckyInfo.count_options;
      const luckyInfo = this.luckyInfo;
      console.log("luckyInfo", luckyInfo, count_options);
      let tapBalance = this.assetsList?.[3].balance;
      if (!count_options && !luckyInfo) {
        return;
      }
      if (type == "stock") {
        if (selectType != "select") {
          this.stockCountStep = count_options.findLastIndex(item => {
            return this.userData.stock >= item * luckyInfo.stock.price_stock && this.userData.coin >= item * luckyInfo.stock.price_coin;
          });
        } else {
          if (this.stockCountStep >= count_options.length - 1) {
            this.stockCountStep = 0;
          } else {
            this.stockCountStep++;
          }
        }
        if (this.userData.stock < count_options[this.stockCountStep] * luckyInfo.stock.price_stock || this.userData.coin < count_options[this.stockCountStep] * luckyInfo.stock.price_coin) {
          this.stockCountStep = count_options.findIndex(item => {
            return this.userData.stock >= item * luckyInfo.stock.price_stock && this.userData.coin >= item * luckyInfo.stock.price_coin;
          });
        }
        if (this.userData.stock < count_options[0] * luckyInfo.stock.price_stock || this.userData.coin < count_options[0] * luckyInfo.stock.price_coin) {
          this.stockCountStep = 0;
        }
        this.stockSelectCountOptions = count_options[this.stockCountStep];
        this.isSelectStock = this.stockCountStep;
      } else if (type == "tap") {
        if (selectType != "select") {
          this.tapCountStep = count_options.findLastIndex(item => {
            console.log("item * luckyInfo.tap.price_tap", tapBalance, item * luckyInfo.tap.price_tap);
            return tapBalance >= item * luckyInfo.tap.price_tap;
          });
        } else {
          if (this.tapCountStep >= count_options.length - 1) {
            this.tapCountStep = 0;
          } else {
            this.tapCountStep++;
          }
        }
        if (tapBalance < count_options[this.tapCountStep] * luckyInfo.tap.price_tap) {
          this.tapCountStep = count_options.findIndex(item => {
            return tapBalance >= item * luckyInfo.tap.price_tap;
          });
        }
        if (tapBalance < count_options[0] * luckyInfo.tap.price_tap) {
          this.tapCountStep = 0;
        }
        console.log("tapBalance=====", tapBalance, count_options[this.tapCountStep] * luckyInfo.tap.price_tap, count_options[this.tapCountStep], luckyInfo.tap.price_tap, this.tapCountStep);
        this.tapSelectCountOptions = count_options[this.tapCountStep];
        this.isSelectTap = this.tapCountStep;
      }
    },
    //开始抽奖
    onStart(type) {
      //校验资格

      //开始转盘

      if (!this.isFlag) return;
      this.btnType = type;
      this.isFlag = false; //防止重复提交
      const vueLuckywheel = this.$refs.vueLuckywheel;
      if (!vueLuckywheel) {
        this.isFlag = true;
        return;
      }
      if (!this.prizeList && this.prizeList.length > 0) {
        this.isFlag = true;
        return;
      }
      const count = this.btnType == "stock" ? this.stockSelectCountOptions : this.tapSelectCountOptions;
      this.luckyDraw([this.luckyInfo.id, async res => {
        this.isStartLucky = true;
        if (res.user) {
          if (res.lottery.price_coin > 0) {
            res.user.coin = res.user.coin - res.lottery.price_coin;
          }
          let newUserData = {
            ...this.userData,
            ...res.user
          };
          this.setUserData(newUserData);
        }
        if (this.btnType == "tap" && this.$refs.nCurrencyTwoRef) {
          this.$refs.nCurrencyTwoRef.tonCurrency.tap.balance -= res.lottery.price_tap;
        }
        this.selectRow = {
          amount: res.winning_item.amount,
          currency: res.winning_item.currency,
          user: res.user
        };
        // this.selectRow = res.winning_item.amount;
        //随机模拟中奖结果 随机数据索引
        //this.prizeIndex = Math.floor(Math.random() * this.prizeList.length);
        this.prizeList.forEach((item, index) => {
          if (item.id == res.winning_item.id) {
            this.awardInfo = res.winning_item;
            this.prizeIndex = index;
          }
        });
        this.isStartLucky = false;
        //执行转盘动画
        this.$nextTick(vueLuckywheel.draw);
      }, err => {
        this.isFlag = true;
      }, this.btnType, count]);
    },
    //中奖结果
    async onResult() {
      //显示中奖结果弹窗
      this.isPopResult = true;
      await this.getGiftShardList();
      this.isStartLucky = false;
      this.isFlag = true;
      // this.setCountOption(this.btnType, 'result');
      const count_options = this.luckyInfo.count_options;
      const luckyInfo = this.luckyInfo;
      if (this.btnType == "stock") {
        const countStep = this.stockCountStep;
        this.stockCountStep = count_options.findLastIndex((item, index) => {
          return this.userData.stock >= item * luckyInfo.stock.price_stock && this.userData.coin >= item * luckyInfo.stock.price_coin;
        });
        if (this.isSelectStock >= 0) {
          this.stockCountStep = this.isSelectStock;
        }
        if (this.userData.stock < count_options[0] * luckyInfo.stock.price_stock || this.userData.coin < count_options[0] * luckyInfo.stock.price_coin) {
          this.stockCountStep = 0;
        }
        console.log("countStep123", countStep, this.stockCountStep);
        this.stockSelectCountOptions = count_options[this.stockCountStep >= 0 ? this.stockCountStep : count_options.length - 1];
      } else if (this.btnType == "tap") {
        const tapBalance = this.assetsList?.[3].balance;
        this.tapCountStep = count_options.findLastIndex(item => {
          return tapBalance >= item * luckyInfo.tap.price_tap;
        });
        if (this.isSelectTap >= 0) {
          this.tapCountStep = this.isSelectTap;
        }
        if (tapBalance < count_options[0] * luckyInfo.tap.price_tap) {
          this.tapCountStep = 0;
        }
        this.tapSelectCountOptions = count_options[this.tapCountStep >= 0 ? this.tapCountStep : count_options.length - 1];
      }
      document.body.scrollTo({
        top: 0,
        left: 0
      });
    },
    //外围灯光动画
    lightAnimFn() {
      this.$nextTick(() => {
        const luckyTableAdroinRef = this.$refs.luckyTableAdroinRef;
        if (!luckyTableAdroinRef) return;
        luckyTableAdroinRef.style.setProperty("--image1", `url(${require(`@images/${this.theme}/lucky/light1-gift.png`)})`);
        luckyTableAdroinRef.style.setProperty("--image2", `url(${require(`@images/${this.theme}/lucky/light2-gift.png`)})`);
      });
    },
    //更新数据

    //获取转盘列表  不做配置就直接在data中写死
    async getLuckyListData() {
      this.isLoadingLuckyList = true;
      this.prizeList = [];
      await this.getLuckyItems(this.luckyInfo.id);
      this.luckyItems.forEach((item, index) => {
        this.prizeList.push({
          id: item.id,
          value: item.amount,
          unit: item.currency,
          type: item.currency.toLowerCase()
        });
      });
      this.isLoadingLuckyList = false;
    },
    // 礼物碎片部分***********************************************************************************************
    // 礼物碎片部分***********************************************************************************************
    // 礼物碎片部分***********************************************************************************************
    // 礼物碎片部分***********************************************************************************************
    // 礼物碎片部分***********************************************************************************************
    // 礼物碎片部分***********************************************************************************************
    // 礼物碎片部分***********************************************************************************************
    // 礼物碎片部分***********************************************************************************************
    // 礼物碎片部分***********************************************************************************************
    popGamerewardConfirm() {
      this.isPopResult = false;
    },
    setGiftSellContentText() {
      const giftSellContent = {
        get: {
          title: `Are you sure you want to <br> receive this gift`,
          content: `You won't be able to exchange it <br> for Telegram stars afterwards`,
          btn: `Get`,
          type: `get`,
          btnSkip: type => {
            this.giftSellBtnSkip(type);
          }
        },
        sell: {
          title: `Are you sure you want to sell it?`,
          content: `will be credited to your balance`,
          btn: `Submit`,
          type: `sell`,
          btnSkip: type => {
            this.giftSellBtnSkip(type);
          }
        },
        get2: {
          0: {
            //电报NFT
            title: `🎁 You’ve won a Gift!<br> Here’s how to get it`,
            content: `
          <p>1.Send a message to <i>@${this.setting.botname}</i> with any content, such as hi, hello, etc.</p>
          <p>2.Your Gift will be delivered within 48 hours after your message — don’t miss it!  </p>
          <p>3.Gift status available in My Gifts. </p>
          `,
            type: "get2",
            btn: `Send a message to <br> our gift admin @${this.setting.botname}`,
            btnSkip: () => {
              this.isPopGiftSellClose = true;
              _v.WebApp.openTelegramLink(`https://t.me/${this.setting.botname}`);
            }
          },
          1: {
            //电报原生礼品
            title: `🎁 You’ve won a Gift!<br> Here’s how to get it`,
            content: `
          <p>1.Send a message to <i>@${this.adminName}</i> with any content, such as hi, hello, etc.</p>
          <p>2.Your Gift will be delivered within 48 hours after your message — don’t miss it! </p>
          <p>3.Gift status available in My Gifts. </p>
          `,
            type: "get2",
            btn: `Send a message to <br> our gift admin @${this.adminName}`,
            btnSkip: () => {
              this.isPopGiftSellClose = true;
              _v.WebApp.openTelegramLink(`https://t.me/${this.adminName.charAt(0).toLowerCase() + this.adminName.slice(1)}`);
            }
          }
        }
      };
      this.giftSellContent = giftSellContent;
    },
    onSkip(name) {
      _v.WebApp.openTelegramLink(`https://t.me/${name}`);
    },
    async initFnc() {
      await this.getGiftShardList();
    },
    async getGiftShardList() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/gift/shard/list", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          // this.giftList = data.sort((a, b) => b.shard_amount - a.shard_amount);
          this.giftList = data.map(item => {
            return {
              ...item,
              isGetLoading: false,
              isSellLoading: false
            };
          }).sort((a, b) => b.shard_amount - a.shard_amount);
          resolve(this.giftList);
        }, () => {
          resolve();
        });
      });
    },
    claimGift(type) {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/gift/claim", {
          giftId: this.rowGift.id,
          type
        });
        vailcode(res, async () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.giftList = data.gifts.map(item => {
            return {
              ...item,
              isGetLoading: false,
              isSellLoading: false
            };
          }).sort((a, b) => b.shard_amount - a.shard_amount);
          const items = this.giftList.filter(it => {
            return it.id == this.rowGift.id;
          });
          if (items && items.length > 0) {
            const itms = items[0];
            // let progress = [];
            // if (itms.shard_amount < itms.required_shards) {
            //   progress = [itms.shard_amount];
            // } else if (itms.shard_amount > itms.required_shards) {
            //   progress = [itms.required_shards, itms.shard_amount - parseInt(itms.shard_amount / itms.required_shards) * itms.required_shards];
            // }

            let progress = [itms.shard_amount];
            this.rowGift = {
              ...itms,
              progress,
              time: parseInt(itms.shard_amount / itms.required_shards),
              index: this.rowGift.index
            };
          }
          resolve(this.giftList);
        }, () => {
          resolve();
        });
      });
    },
    async onShowMyGift() {
      this.popMyGiftShow = true;
      this.myGiftAddEventListenerScroll();
    },
    async onOpenMarket() {
      this.WebApp.openLink("https://getgems.io/top-gifts");
    },
    onShowGiftDetail(item, index) {
      let progress = [item.shard_amount];
      this.rowGift = {
        ...item,
        progress,
        time: parseInt(item.shard_amount / item.required_shards),
        index
      };
      this.popGiftDetailShow = true;
    },
    setGiftSellContent(item, type) {
      if (type == 0) {
        this.rowGiftSellContent = this.giftSellContent["get"];
      } else {
        const sell = this.giftSellContent["sell"];
        sell.content = `${this.rowGift.recycling_stars} <img src="${require("@images/tapcoin/lucky/icon-star.png")}" alt="" /> will be credited to your balance`;
        this.rowGiftSellContent = sell;
      }
    },
    onShowGiftSell(item, type) {
      this.setGiftSellContent(item, type);
      this.popGiftSellShow = true;
    },
    async giftSellBtnSkip(type) {
      if (type == "get" && this.rowGift.gift_type == 0) {
        if (this.giftList[this.rowGift.index].isGetLoading) return;
        this.giftList[this.rowGift.index].isGetLoading = true;
        const res = await this.claimGift(0);
        if (!res) {
          this.giftList[this.rowGift.index].isGetLoading = false;
          return;
        }
        this.rowGiftSellContent = this.giftSellContent["get2"][0];
      } else if (type == "get" && this.rowGift.gift_type == 1) {
        if (this.giftList[this.rowGift.index].isGetLoading) return;
        this.giftList[this.rowGift.index].isGetLoading = true;
        const res = await this.claimGift(0);
        if (!res) {
          this.giftList[this.rowGift.index].isGetLoading = false;
          return;
        }
        this.rowGiftSellContent = this.giftSellContent["get2"][1];
      } else if (type == "sell") {
        this.isGiftSellUpStarBalance = false;
        console.log('this.giftList[this.rowGift.index].isSellLoading ', this.giftList[this.rowGift.index].isSellLoading);
        if (this.giftList[this.rowGift.index].isSellLoading) return;
        this.giftList[this.rowGift.index].isSellLoading = true;
        const res = await this.claimGift(1);
        this.giftList[this.rowGift.index].isSellLoading = true;
        if (!res) {
          this.giftList[this.rowGift.index].isSellLoading = false;
          return;
        }
        await this.getAssetsList();
        this.$toasted.success("sell successfully");
        this.isGiftSellUpStarBalance = true;
        setTimeout(() => {
          this.giftList[this.rowGift.index].isSellLoading = false;
          this.popGiftSellShow = false;
        }, 3000);
      }
    },
    getMyGiftList(page = 1, limit = 10) {
      this.myGiftListPage.isLoading = true;
      // 模拟后端总数据
      // const allItems = Array.from({ length: 35 }, (_, i) => ({
      //   id: i + 1,
      //   gift_id: 5,
      //   gift_type: 0,
      //   gift_name: "",
      //   gift_thumb: "https://tstatic.humanpass.net/202507/25/3d490fc3-ac70-4b1e-ad23-ed0c14ebc3f6.png",
      //   gift_image: "https://tstatic.humanpass.net/202507/25/b08ad29b-02f7-4e23-95d4-815cc37c9954.png",
      //   gift_stars: 25,
      //   gift_status: 0,
      //   recycling_stars: 0,
      //   status: 0,
      //   created_at: new Date().toISOString(),
      // }));

      // const total = allItems.length;
      // const start = (page - 1) * limit;
      // const end = page * limit;
      // const paginatedItems = allItems.slice(start, end);

      // const res = {
      //   code: 0,
      //   message: "",
      //   data: {
      //     total,
      //     perPage: limit,
      //     lastPage: Math.ceil(total / limit),
      //     currentPage: page,
      //     items: paginatedItems,
      //   },
      // };
      return new Promise(async resolve => {
        const res = await _v.$http.post("/gift/my/list", {
          page,
          limit
        });
        vailcode(res, () => {
          const items = res.data.items || [];
          if (page === 1) {
            this.myGiftList = items;
          } else {
            this.myGiftList.push(...items);
          }
          this.myGiftListPage.totalPages = res.data.lastPage;
          this.myGiftListPage.page = page;
          this.myGiftListPage.isLoading = false;
          resolve(items);
        }, () => {
          this.myGiftListPage.isLoading = false;
          resolve([]);
        });
      });
    },
    async myGiftHandleScroll(e) {
      const el = e.target;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10 && !this.myGiftListPage.isLoading && this.myGiftListPage.page < this.myGiftListPage.totalPages) {
        this.getMyGiftList(this.myGiftListPage.page + 1, this.myGiftListPage.limit);
      }
    },
    myGiftAddEventListenerScroll() {
      this.$nextTick(() => {
        const container = this.$refs.popmygift;
        console.log(this.$el, "container", container);
        setTimeout(() => {
          this.getMyGiftList(1, this.myGiftListPage.limit);
          if (container) {
            container.onscroll = this.myGiftHandleScroll;
          }
        }, 200);
      });
    }
  },
  mounted() {
    this.$nextTick(async () => {
      console.log("this.$refs.nCurrencyRef", this.$refs.nCurrencyTwoRef);
      if (this.$refs.nCurrencyTwoRef) {
        await this.$refs.nCurrencyTwoRef.getCurrencyData();
      }
      await this.getLuckyList(["official", 10]);
      if (this.luckyList && this.luckyList.length > 0) {
        const data = this.luckyList[0];
        this.luckyInfo = {
          ...data,
          stock: {
            price_stock: data.price_stock,
            price_coin: data.price_coin
          },
          tap: {
            price_tap: data.price_extras.hasOwnProperty("tap") ? data.price_extras?.tap.price_tap : 0,
            price_coin: data.price_extras.hasOwnProperty("tap") ? data.price_extras?.tap.price_coin : 0
          }
        };
        this.getLuckyListData();
      }
      this.lightAnimFn();
      await this.initFnc();
      this.setGiftSellContentText();
      this.setCountOption("stock", "init");
      this.setCountOption("tap", "init");
    });
  },
  beforeRouteLeave(to, from, next) {
    try {
      this.isPopResult = false;
    } catch (error) {}
    next();
  }
};